import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import { Typography } from '@/components/Typography/Typography';
import WarningSecondaryIcon from '@/images/WarningSecondaryIcon.svg?react';
import { COLORS } from '@/styles/colors';

type DowngradePlanPreviewModalType = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DowngradePlanPreviewModal = ({ isOpen, onConfirm, onCancel }: DowngradePlanPreviewModalType) => {
  return (
    <ModalWindow isOpen={isOpen} width='504px'>
      <Box display='flex' flexDirection='column' rowGap='28px' alignItems='center'>
        <Box display='flex' flexDirection='column' rowGap='20px' alignItems='center'>
          <WarningSecondaryIcon />
          <Box display='flex' flexDirection='column' rowGap='12px' alignItems='center'>
            <Typography variant='headline4' color={COLORS.black} fontWeight='semibold'>
              Please Review Before Reactivating
            </Typography>

            <Box display='flex' flexDirection='column' rowGap='12px'>
              <Typography color={COLORS.grey[950]}>
                You`ve selected a plan with a <b>lower user limit</b> than your previous subscription.
                <br />
                <b>Once reactivated:</b>
              </Typography>
              <Box as='ul' margin='0' paddingLeft='30px'>
                <li>
                  <b>Only you</b> (as the Master Admin) will remain <b>active</b>.
                </li>
                <li>
                  All <b>other Admins</b> in your organization will be temporarily blocked.
                </li>
                <li>
                  You`ll need to <b>manually unblock</b> the necessary Admins to match the new plan`s user limit.
                </li>
              </Box>
              <Typography>If that works for you, proceed to complete your subscription reactivation.</Typography>
            </Box>
          </Box>
        </Box>

        <Box display='flex' flexDirection='column' width='100%' rowGap='12px' marginTop='12px'>
          <Button onClick={onConfirm} mobileStretch>
            Reactivate Subscription
          </Button>
          <Button variant='secondary' onClick={onCancel} mobileStretch>
            Cancel
          </Button>
        </Box>
      </Box>
    </ModalWindow>
  );
};
